export const SHEET_URL =
  "https://script.google.com/macros/s/AKfycbyXsviOzOcoXQz3klaVFUkK60ayn93EwBLbnowxvNtlXcKEl89ROX1nHTDJLIYr2UFR/exec"

export const CONTENT_URL = "/kirby/content:1"

export interface ContactData {
  Name: string
  Email: string
  Message: string
}

export interface ContactResponse {
  error: null | string
}

export interface ContentData {
  backgroundColor: string
  about: string
  footer: string
  privacyPolicy: string
}
